import { render, staticRenderFns } from "./purreturnview.vue?vue&type=template&id=f7bc618c&scoped=true&"
import script from "./purreturnview.vue?vue&type=script&lang=js&"
export * from "./purreturnview.vue?vue&type=script&lang=js&"
import style0 from "./purreturnview.vue?vue&type=style&index=0&id=f7bc618c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bc618c",
  null
  
)

export default component.exports